import moment from 'moment'
import { flatten } from 'lodash'
import { log } from 'async'

export const getLastMonthAndCurrentRanges = () => {
  const today = moment.utc()
  const thisMonthStart = moment.utc(today).startOf('month')
  const thisMonthEnd = moment.utc(today).endOf('month')
  const lastMonthStart = moment
    .utc(thisMonthStart)
    .subtract(1, 'month')
    .startOf('month')
  const lastMonthEnd = moment.utc(lastMonthStart).endOf('month')

  return {
    lastMonth: { start: lastMonthStart.toDate(), end: lastMonthEnd.toDate() },
    thisMonth: { start: thisMonthStart.toDate(), end: thisMonthEnd.toDate() },
  }
}
export const groupTimeEntries = (timeEntries, timesheets, weeks) => {
  const timesheetsMap = timesheets.reduce((acc, timesheet) => {
    acc[timesheet.repliconId] = timesheet.approvalStatus === 'Approved'
    return acc
  }, {})

  // Group time entries by project --> week --> person
  // {'projectId: { week: { personId: { entries: [] } } } }

  const grouped = timeEntries.reduce((acc, entry) => {
    if (entry.approveState.status !== 'pending') {
      return acc
    }
    const week = weeks.find(currentWeek => {
      const entryDate = moment.utc(entry.entryDate)
      return entryDate.isBetween(currentWeek.start, currentWeek.end, null, '[]')
    })

    if (!week) {
      console.warn('No week found for entry', entry)
      return acc
    }

    const timesheet = timesheetsMap[entry.repliconTimesheetId]
    if (!timesheet) return acc
    if (!acc[entry.projectId]) {
      acc[entry.projectId] = {}
    }

    if (!acc[entry.projectId][week.stringWeek]) {
      acc[entry.projectId][week.stringWeek] = {}
    }

    if (!acc[entry.projectId][week.stringWeek][entry.personId]) {
      acc[entry.projectId][week.stringWeek][entry.personId] = []
    }

    acc[entry.projectId][week.stringWeek][entry.personId].push({
      ...entry,
      weekDay: moment.utc(entry.entryDate).format('dddd'),
    })

    return acc
  }, {})

  return grouped
}
// Returns the number of weekdays (Monday-Friday) in a given month.
// Month is 0-indexed (0 for January, 11 for December).
export function getNumberOfWeekdaysInMonth(year, month) {
  const startOfMonth = moment([year, month]).startOf('month')
  const endOfMonth = moment([year, month]).endOf('month')
  let count = 0
  for (let day = startOfMonth.date(); day <= endOfMonth.date(); day++) {
    const currentDay = moment([year, month, day])
    // moment().day(): 0 = Sunday, 6 = Saturday
    if (currentDay.day() !== 0 && currentDay.day() !== 6) {
      count++
    }
  }
  return count
}

// Returns the number of weekdays in the week that fall within the provided month and year.
export function getWeekdaysInWeekForMonth(week, year, month) {
  const startOfWeek = moment(week).startOf('week')
  const endOfWeek = moment(week).endOf('week')
  let count = 0
  for (let day = startOfWeek.clone(); day.isSameOrBefore(endOfWeek, 'day'); day.add(1, 'day')) {
    if (day.year() === year && day.month() === month && day.day() !== 0 && day.day() !== 6) {
      count++
    }
  }
  return count
}

// Instead of calculating based on whole weeks, we now calculate based on weekdays.
// This function now uses the pacingWeek object from wipReport instead of calculating from timeEntries
// The pacingWeek object uses ISO week numbers as keys: {52: 1000, 53: 10000, ...}
export const calculateBudgetAndPacingInWeek = (week, project, wipReport) => {
  if (!week || !project || !wipReport) return {}

  const monthBudget = wipReport.budget || 0
  const pacingWeek = wipReport.pacingWeek || {}

  // Get the ISO week number for the selected week
  // ISO week numbers range from 1-53 and represent the week of the year
  const weekIsoNumber = moment(week).isoWeek()

  // Look up the pacing value for this week using the ISO week number as the key
  // If the week is not found in the object, default to 0
  // pacingWeek contains the pacing values (actual - expected) for each week
  const actualPacing = pacingWeek[weekIsoNumber] !== undefined ? pacingWeek[weekIsoNumber] : 0

  // actualUsed should be the total actual amount used for the month
  // This comes from totalFeesAndExpenses in the wipReport
  const actualUsed = wipReport.submittedHours?.staffRate || 0

  return {
    monthBudget,
    actualPacing,
    actualUsed,
    noBudget: monthBudget === 0,
  }
}
